const EventCodes = {
  OPEN_SUPPORT_CHAT: 'OPEN_SUPPORT_CHAT',
};

export default EventCodes;
